export const PERFUME_TITLE = "Queremos saber perfumes e chocolate que você gosta.. 💖";
export const PERFUME_DESCRIPTION = "Responda rapidinho — ajuda a gente a te presentear.";

export const PREF_PERFUMES_NAME = "pref_perfumes";
export const PREF_CHOCOLATE_NAME = "pref_chocolate";
export const PREF_CHOCOLATE_QUAL_NAME = "pref_chocolate_qual";

export const CHOCOLATE_NO = "Não gosto de chocolate";

export const CHOCOLATE_OPTIONS = [
  "Adoro chocolate",
  "Gosto às vezes",
  CHOCOLATE_NO,
];

export const PERFUME_PLACEHOLDER = "Ex: Chanel Nº5, Libre YSL, Good Girl...";
export const CHOCOLATE_QUAL_PLACEHOLDER = "Ex: Lindt, Ferrero, chocolate amargo 70%...";

export const DEFAULT_PERFUME_FIELDS = [
  {
    name: PREF_PERFUMES_NAME,
    label: "Quais seus três perfumes favoritos? Podemos te presentear se já for nossa cliente",
    type: "text",
    required: true,
  },
  {
    name: PREF_CHOCOLATE_NAME,
    label: "E chocolate, você curte?",
    type: "radio",
    options: [...CHOCOLATE_OPTIONS],
    required: true,
  },
  {
    name: PREF_CHOCOLATE_QUAL_NAME,
    label: "Qual chocolate você prefere?",
    type: "text",
    required: false,
  },
];

export function isPerfumeSurvey(survey) {
  if (!survey) return false;
  const title = String(survey.title || "").toLowerCase();
  if (title.includes("perfum") || title.includes("chocolate")) return true;
  const fields = survey.fields || [];
  return fields.some((f) => f.name === PREF_PERFUMES_NAME || f.name === PREF_CHOCOLATE_NAME);
}

export function normalizePerfumeSurveyFields(fields) {
  const rows = (Array.isArray(fields) ? [...fields] : []).map((f) => ({ ...f }));
  const byName = (name) => rows.find((f) => f.name === name);

  let perfumes = byName(PREF_PERFUMES_NAME) || rows.find((f) => String(f.label || "").toLowerCase().includes("perfum"));
  if (!perfumes) {
    perfumes = { ...DEFAULT_PERFUME_FIELDS[0] };
    rows.unshift(perfumes);
  } else {
    Object.assign(perfumes, DEFAULT_PERFUME_FIELDS[0]);
  }

  let chocolate = byName(PREF_CHOCOLATE_NAME);
  if (!chocolate) {
    chocolate = { ...DEFAULT_PERFUME_FIELDS[1] };
    const pi = rows.findIndex((f) => f.name === PREF_PERFUMES_NAME);
    rows.splice(pi + 1, 0, chocolate);
  } else {
    Object.assign(chocolate, DEFAULT_PERFUME_FIELDS[1]);
  }

  let qual = byName(PREF_CHOCOLATE_QUAL_NAME);
  if (!qual) {
    qual = { ...DEFAULT_PERFUME_FIELDS[2] };
    const ci = rows.findIndex((f) => f.name === PREF_CHOCOLATE_NAME);
    rows.splice(ci + 1, 0, qual);
  } else {
    Object.assign(qual, DEFAULT_PERFUME_FIELDS[2]);
  }

  return rows.filter((f) =>
    [PREF_PERFUMES_NAME, PREF_CHOCOLATE_NAME, PREF_CHOCOLATE_QUAL_NAME].includes(f.name),
  );
}

export function displayFieldLabel(field) {
  if (field?.name === PREF_PERFUMES_NAME) return DEFAULT_PERFUME_FIELDS[0].label;
  if (field?.name === PREF_CHOCOLATE_NAME) return DEFAULT_PERFUME_FIELDS[1].label;
  if (field?.name === PREF_CHOCOLATE_QUAL_NAME) return DEFAULT_PERFUME_FIELDS[2].label;
  return field?.label || "";
}

export function showChocolateQual(answers) {
  const v = answers?.[PREF_CHOCOLATE_NAME];
  return v && v !== CHOCOLATE_NO;
}

const JUNK_ANSWERS = new Set([
  ".", "..", "...", "—", "-", "x", "xx", "xxx", "ok", "n/a", "na",
  "nenhum", "nao sei", "não sei", "sei la", "sei lá", "skip", "asd", "teste",
]);

/** Rejeita "...", traços e texto sem letras reais. */
export function isMeaningfulText(value, minLen = 3) {
  const raw = String(value || "").trim();
  if (raw.length < minLen) return false;
  if (JUNK_ANSWERS.has(raw.toLowerCase())) return false;
  if (/^[\W_]+$/.test(raw)) return false;
  return /[a-zA-ZÀ-ÿ]{2,}/.test(raw);
}

export function isEmptyAnswer(field, value, answers) {
  if (field?.name === PREF_PERFUMES_NAME) {
    return !isMeaningfulText(value, 3);
  }
  if (field?.name === PREF_CHOCOLATE_QUAL_NAME) {
    if (!showChocolateQual(answers)) return false;
    return !isMeaningfulText(value, 2);
  }
  if (field?.type === "radio" || field?.name === PREF_CHOCOLATE_NAME) {
    return !value;
  }
  return !String(value || "").trim();
}

export function isSurveyComplete(fields, answers) {
  if (!Array.isArray(fields)) return false;
  return fields.every((field) => {
    if (field.name === PREF_CHOCOLATE_QUAL_NAME && !showChocolateQual(answers)) {
      return true;
    }
    if (
      field.name === PREF_PERFUMES_NAME
      || field.name === PREF_CHOCOLATE_QUAL_NAME
      || field.required
    ) {
      return !isEmptyAnswer(field, answers[field.name], answers);
    }
    return true;
  });
}
